import React from 'react'

const OptionsHorizontal = ({
  fill,
  height,
  viewBox,
  width,
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox}>
    <path d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0m0 22.154A10.154 10.154 0 1 1 22.154 12 10.15 10.15 0 0 1 12 22.154" fill={fill}/>
    <circle cx="1.655" cy="1.655" r="1.655" transform="translate(5.289 10.345)" fill={fill}/>
    <circle cx="1.655" cy="1.655" r="1.655" transform="translate(10.345 10.345)" fill={fill}/>
    <circle cx="1.655" cy="1.655" r="1.655" transform="translate(15.4 10.345)" fill={fill}/>
  </svg>
)

export default OptionsHorizontal